export function defaultValueIfUndefined<T>({ val, defaultVal }: { val: T | undefined; defaultVal: T }): T {
  return val === undefined ? defaultVal : val;
}
